import axios from "axios"

interface AxiosConfig {
    url: string,
    method: string,
    params?: any,
    data?: any,
    headers?: any
}

export const AxiosWrapper = (config: AxiosConfig) => {
    // Get global region filter from sessionStorage
    const globalRegionId = sessionStorage.getItem('global-region-filter');
    
    // Add region_id to params if it exists and is not already set
    let params = config.params || {};
    if (globalRegionId && !params.region_id && !params.region) {
        params = {
            ...params,
            filter: {
            ...(params.filter || {}),
            region: globalRegionId
            }
        };
    }
    
    return axios({
        baseURL: process.env.REACT_APP_BASE_URL,
        url: config.url,
        method: config.method,
        params: params,
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`
        },
        data: config.data
    });
}